<div class="message-text">
	<div class="text">{{ elements.payload.values[0] }}</div>
</div>